{
  "RIS": {
    "ABST": "article-journal",
    "ADVS": "motion_picture",
    "AGGR": "dataset",
    "ANCIENT": "classic",
    "ART": "graphic",
    "BILL": "bill",
    "BLOG": "post-weblog",
    "BOOK": "book",
    "CASE": "legal_case",
    "CHAP": "chapter",
    "CHART": "figure",
    "CLSWK": "classic",
    "COMP": "software",
    "CONF": "paper-conference",
    "CPAPER": "paper-conference",
    "CTLG": "entry",
    "DATA": "dataset",
    "DBASE": "dataset",
    "DICT": "entry-dictionary",
    "EBOOK": "book",
    "ECHAP": "chapter",
    "EDBOOK": "book",
    "EJOUR": "article-journal",
    "ELEC": "webpage",
    "ENCYC": "entry-encyclopedia",
    "EQUA": "article",
    "FIGURE": "figure",
    "GEN": "document",
    "GOVDOC": "report",
    "GRANT": "article",
    "HEAR": "hearing",
    "ICOMM": "personal_communication",
    "INPR": "article-journal",
    "JFULL": "article-journal",
    "JOUR": "article-journal",
    "LEGAL": "legislation",
    "MANSCPT": "manuscript",
    "MAP": "map",
    "MGZN": "article-magazine",
    "MPCT": "broadcast",
    "MULTI": "motion_picture",
    "MUSIC": "musical_score",
    "NEWS": "article-newspaper",
    "PAMP": "pamphlet",
    "PAT": "patent",
    "PCOMM": "personal_communication",
    "RPRT": "report",
    "SER": "periodical",
    "SLIDE": "motion_picture",
    "SOUND": "motion_picture",
    "STAND": "standard",
    "STAT": "legislation",
    "THES": "thesis",
    "UNBILL": "manuscript",
    "UNPB": "manuscript",
    "VIDEO": "motion_picture",
    "WEB": "webpage"
  },
  "CSL": {
    "article-journal": "JOUR",
    "article-magazine": "MGZN",
    "article-newspaper": "NEWS",
    "article": "JOUR",
    "bill": "BILL",
    "book": "BOOK",
    "broadcast": "MPCT",
    "chapter": "CHAP",
    "classic": "CLSWK",
    "collection": "GEN",
    "dataset": "DATA",
    "document": "GEN",
    "entry": "CTLG",
    "entry-dictionary": "DICT",
    "entry-encyclopedia": "ENCYC",
    "event": "GEN",
    "figure": "FIGURE",
    "graphic": "ART",
    "hearing": "HEAR",
    "interview": "GEN",
    "legal_case": "CASE",
    "legislation": "LEGAL",
    "manuscript": "MANSCPT",
    "map": "MAP",
    "motion_picture": "MPCT",
    "musical_score": "MUSIC",
    "pamphlet": "PAMP",
    "paper-conference": "CONF",
    "patent": "PAT",
    "performance": "GEN",
    "periodical": "SER",
    "personal_communication": "PCOMM",
    "post-weblog": "BLOG",
    "post": "ICOMM",
    "regulation": "LEGAL",
    "report": "RPRT",
    "review-book": "BOOK",
    "review": "JOUR",
    "software": "COMP",
    "song": "SOUND",
    "speech": "SOUND",
    "standard": "STAND",
    "thesis": "THES",
    "treaty": "GEN",
    "webpage": "ELEC"
  }
}
